import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';
import { HANUMAN_COLORS } from './hanumanColors';

const Banner = styled.div`
  margin: ${p => p.theme.spacing[4]}px auto;
  max-width: 560px;
  padding: ${p => p.theme.spacing[3]}px ${p => p.theme.spacing[4]}px;
  background: #FFF3E0;
  border-left: 3px solid ${HANUMAN_COLORS.primary};
  border-radius: 6px;
  font-size: 14px;
  color: ${p => p.theme.colors.text.secondary};
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  line-height: 1.6;
  text-align: center;
`;

const Countdown = styled.div`
  margin-top: ${p => p.theme.spacing[2]}px;
  font-weight: 600;
  color: ${HANUMAN_COLORS.primaryDark};
`;

const LastReadingLink = styled.button`
  display: block;
  margin: ${p => p.theme.spacing[2]}px auto 0;
  background: none;
  border: none;
  color: ${HANUMAN_COLORS.primary};
  text-decoration: underline;
  cursor: pointer;
  font-size: 13px;
`;

function formatCountdown(msRemaining, t) {
  const minutes = Math.ceil(msRemaining / 60000);
  if (minutes < 1) return t.cooldownLessThanMinute || 'Next question in less than a minute';
  return (t.cooldownRemaining || 'Next question in {n} minutes').replace('{n}', minutes);
}

const HanumanCooldown = ({ msRemaining, onViewLastReading, hasLastReading, lang }) => {
  const t = useLocale(lang, 'hanumanPrashnavali');
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick(n => n + 1), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <Banner role="status" aria-live="polite">
      {t.cooldownMessage || "Traditional practice asks us to reflect on Hanuman's counsel for one hour"}
      <Countdown>{formatCountdown(msRemaining, t)}</Countdown>
      {hasLastReading && (
        <LastReadingLink onClick={onViewLastReading}>
          {t.viewLastReading || 'View your last reading'}
        </LastReadingLink>
      )}
    </Banner>
  );
};

export default HanumanCooldown;
